'use client';
import { isFunction } from '@s7/utils';
import { arrow } from './core/middleware/arrow.js';

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 */ const arrowSafe = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options,
        fn (state) {
            const { element, padding } = isFunction(options) ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) {
                    return arrow({
                        element: element.current,
                        padding
                    }).fn(state);
                }
                return {};
            } else if (element) {
                return arrow({
                    element,
                    padding
                }).fn(state);
            }
            return {};
        }
    };
};

export { arrowSafe };
//# sourceMappingURL=arrowSafe.js.map
